const serviceExtractor = /services\/([^/]+)\/\d+\.\d+\.\d+\/([^.]+)\./

interface ServiceExtractionResult {
	widget?: string
	app?: string
}
export function extractService(url: string): ServiceExtractionResult {
	const matches = url.match(serviceExtractor)
	return {
		app: matches?.[1],
		widget: matches?.[2],
	}
}
